import type { QueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { ConfirmProvider } from "@/components/layout/confirm-provider";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryProvider } from "./query-provider";
// Side effect: configures the generated API client (base URL, auth, errors).
import "@/lib/api/client";

/**
 * App-wide providers, outermost first. Add new providers here (theme, i18n,
 * analytics) so main.tsx and tests share one composition.
 */
export function AppProviders({
  queryClient,
  children,
}: {
  queryClient: QueryClient;
  children: ReactNode;
}) {
  return (
    <QueryProvider client={queryClient}>
      <TooltipProvider delayDuration={200}>
        <ConfirmProvider>{children}</ConfirmProvider>
      </TooltipProvider>
      <Toaster position="top-right" richColors closeButton />
    </QueryProvider>
  );
}
